import clsx, { ClassValue } from "clsx";

type Props = Readonly<{
  message?: string;
  className?: ClassValue;
}>;

export const InputError = ({ message, className }: Readonly<Props>): JSX.Element => {
  if (!message) {
    return <></>;
  }

  return (
    <div className={clsx("mt-2 flex flex-1 items-center gap-2", className)}>
      <span className="input-error flex-1 text-end font-light">{message}</span>
    </div>
  );
};
